import React from "react";
import { Box, Chip, Tooltip, IconButton } from "@mui/material";
import { Cancel, CheckCircleOutline, Add, Edit } from "@mui/icons-material";

const ToolsCheckboxes = ({
    tools,
    selectedTools,
    onToolChange,
    disabledTools,
    customTools,
    onAddCustomTool,
    onDeleteCustomTool,
    onEditCustomTool
}) => {
    
    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                alignItems: "center"
            }}
        >
            {tools.map((tool) => {
                const isDisabled = disabledTools.includes(tool);
                const isSelected = selectedTools.includes(tool);

                return (
                    <Tooltip
                        key={tool}
                        title={
                            isDisabled
                                ? "Still in development. Coming soon!"
                                : isSelected
                                    ? "Click to remove"
                                    : "Click to select"
                        }
                        arrow
                        disableInteractive
                    >
                        <span>
                            <Chip
                                label={tool}
                                onClick={() => !isDisabled && onToolChange(tool, !isSelected)}
                                size="small"
                                disabled={isDisabled}
                                icon={<CheckCircleOutline />}
                                sx={{
                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                    backgroundColor: isSelected ? "#e7e4e4" : "transparent", // Light gray when selected
                                    color: "black",
                                    border: "1px solid",
                                    borderColor: isSelected ? "#008000" : "#ccc", // Green border when selected
                                    "& .MuiChip-icon": {
                                        color: isSelected ? "#008000" : "inherit"
                                    },
                                    "&:hover": {
                                        backgroundColor: isSelected ? "#e0e0e0" : "rgba(0, 0, 0, 0.1)",
                                    },
                                    opacity: isDisabled ? 0.5 : 1
                                }}
                            />
                        </span>
                    </Tooltip>
                );
            })}

            {customTools.map((tool, index) => {
                const isSelected = selectedTools.includes(tool.name);

                return (
                    <Tooltip
                        key={index}
                        title={isSelected ? "Click to remove" : "Click to select"}
                        arrow
                        disableInteractive
                    >
                        <span style={{ display: "flex", alignItems: "center" }}>
                            <Chip
                                label={tool.name}
                                onClick={() => onToolChange(tool.name, !isSelected)}
                                onDelete={() => onDeleteCustomTool(index)}
                                size="small"
                                sx={{
                                    cursor: "pointer",
                                    backgroundColor: isSelected ? "#e7e4e4" : "transparent",
                                    color: "black",
                                    border: "1px solid",
                                    borderColor: isSelected ? "#008000" : "#ccc",
                                    "& .MuiChip-icon": { color: isSelected ? "#008000" : "inherit" },
                                    "&:hover": {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)"
                                    }
                                }}
                            />
                            <Tooltip title="Edit custom tool" arrow>
                                <IconButton
                                    size="small"
                                    onClick={() => onEditCustomTool(index)}
                                    sx={{ ml: 0.5, p: 0.5 }}
                                >
                                    <Edit sx={{ fontSize: 16 }} />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </Tooltip>
                );
            })}

            <Tooltip title="Add Custom Tool" arrow>
                <Chip
                    label="Add Custom Tool"
                    onClick={onAddCustomTool}
                    size="small"
                    icon={<Add fontSize="small" />}
                    sx={{
                        cursor: "pointer",
                        backgroundColor: "transparent",
                        color: "black",
                        border: "1px solid #ccc",
                        "& .MuiChip-icon": { color: "inherit" },
                        "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.1)"
                        }
                    }}
                />
            </Tooltip>
        </Box>
    );
};

export default ToolsCheckboxes;
